<template>
  <div class="module-detail-container">
    <!-- 主内容区 -->
    <div class="module-content">
      <!-- 1. 模块专属图片 -->
      <div class="module-specific-image">
        <img class="img" style="height: 730px" :src="currentModule.url" :alt="currentModule.title" />
      </div>
    </div>
    <bottom-url />
  </div>
</template>

<script>
import bottomUrl from '@/components/bottomUrl/bottomUrl.vue';
import { scrollTop } from '@/util/scrollTop';
export default {
  components: {
    bottomUrl,
  },
  data() {
    return {
      // 8个模块的配置数据
      currentModule: {
        title: '供应链金融',
        url: require('@/assets/recycling/index/bg1.svg'),
      },
    };
  },
  mounted() {},
  methods: {},
};
</script>

<style lang="less" scoped>
.module-detail-container {
  width: 100%;
  margin: 0 auto;
  overflow-y: auto;
  height: calc(100vh - 90px);
  position: relative;
}

.module-content {
  width: 100%;
  text-align: center;
}

/* 模块专属图片样式 */
.module-specific-image {
  width: 100%;
  height: 100%;
  display: block;
}

.module-specific-image img {
  width: 100%;
  height: 100%;
  object-fit: cover;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
}

/* 公用空状态图片样式 */
.empty-state-image {
  width: 100%;
  max-width: 430px;
  height: 304px;
  margin: 0 auto 40px;
  display: block;
  opacity: 0.7;
}

.empty-state-image img {
  width: 100%;
  height: 100%;
  object-fit: contain;
}

/* 开发中提示样式 */
.development-notice {
  background-color: #f8f9fa;
  border-radius: 6px;
  color: #6c757d;
  font-size: 18px;
  text-align: center;
  padding: 15px 0;
  margin: 0 auto;
  width: 80%;
  max-width: 500px;
}

/* 响应式设计 */
@media (max-width: 768px) {
  .module-content {
    height: auto;
    padding: 0 16px 180px;
    background-size: 90% auto; /* 移动端适当缩小 */

    .module-specific-image .img {
      height: auto !important;
    }
  }

  .empty-state-image {
    height: auto;
  }

  .development-notice {
    font-size: 16px;
    padding: 12px;
  }
}

</style>
